import {Component, ViewChild, ElementRef, OnInit, AfterViewInit, OnDestroy,Renderer2 }   from '@angular/core';
import {AuthService} from '../auth/auth.service';
import {Router} from '@angular/router';
import { environment } from 'environments/environment';
//import { FooterInterface } from './footer.interface';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements  AfterViewInit, OnDestroy, OnInit {

  @ViewChild('stickyfooter')
  public stickyFooter: ElementRef;
  heightVal = window.innerHeight;
  showStyle = false;
  baseSystem=environment.baseSystem;


  public today: number = Date.now();
  constructor(public _authService: AuthService,
              private _router: Router, private renderer: Renderer2, public _el: ElementRef) {
 }

  ngAfterViewInit(){}

  ngOnInit(){}

  ngOnDestroy(){}

  getStyle() {
    if( this._router.url == "/landingpage" ) {
      this.showStyle = true;
    }else{
      this.showStyle = false;
    }

    if(this.showStyle) {
      return "initial";
    } else {
      return "";
    }
  }

}





// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.ts